export enum FeatureToggles {
  CONFIG_OVERRIDES = 'configOverrides',
  ONETRUST_ENABLED = 'privacy.oneTrustEnabled',
  SUBSCRIPTION_INFO_REFACTORING = 'subscription.infoPageRefactoring',
  WONDERFUL_THEME_ENABLED = 'contactUs.wonderfulThemeEnabled',
}

export const FeatureToggleDefaults = {
  [FeatureToggles.CONFIG_OVERRIDES]: {},
  [FeatureToggles.ONETRUST_ENABLED]: false,
  [FeatureToggles.SUBSCRIPTION_INFO_REFACTORING]: {
    plus: false,
    partner: false,
    reward: false,
    amazon: false,
  },
  [FeatureToggles.WONDERFUL_THEME_ENABLED]: false,
};

export interface AppBannerConfig {
  message: string;
}
